import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Entity } from '@app/app.model';
import { ErrorsService } from '@app/_shared/errors/errors.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment as e } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { BankAccount, BankAccountInterface } from './bank-account.model';

@Injectable({
  providedIn: 'root'
})
export class BankAccountService implements BankAccountInterface {

  constructor(private _http: HttpClient, private errors$: ErrorsService) { }

  private listRetrieved: BehaviorSubject<BankAccount[]> = new BehaviorSubject<BankAccount[]>(undefined);
  ListRetrieved = this.listRetrieved.asObservable();

  save: (data: Entity<BankAccount>) => Observable<any>;
  getEntity: (data: any) => Observable<any>;

  notifyRetrieved(data: BankAccount[]): void {
    this.listRetrieved.next(data);
  }

  getList(): Observable<BankAccount[]> {
    return this._http.get<BankAccount[]>(e.endpoint.settings.bankAccount)
    .pipe(catchError(this.errors$.handleNetworkError));
  }

  create(data: Entity<BankAccount>): Observable<any> {
    return this._http.put<BankAccount>(
      e.endpoint.settings.bankAccount,
      data.value).pipe(catchError(this.errors$.handleNetworkError));
  }

  delete(param: any): Observable<any> {
    return this._http.delete(e.endpoint.settings.bankAccount + "/" + param.BankAccountId, {
      responseType: "text"
    },).pipe(catchError(this.errors$.handleNetworkError));
  }

  getNewEntity() {
    return this._http.get<BankAccount>(e.endpoint.settings.bankAccount + '/newbankaccount')
    .pipe(catchError(this.errors$.handleNetworkError));
  }

}
